import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import StyledModal from "../../Modals/StyledModal/StyledModal";
import FormControlLabel from "@mui/material/FormControlLabel";
import PrimaryButton from "../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../Buttons/SecondaryButton/SecondaryButton";
import PrimaryCheckbox from "../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import { CarrierService } from "../../../services/CarrierService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function CarrierProfileCapacityExpireModal({
  setOpen,
  userIdMcld,
  capacityType,
  selectedLanes,
  setRefreshPage
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isOpen, setIsOpen] = useState(false);
  const [confirmExpire, setConfirmExpire] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setOpen(false);
  };

  const handleCancel = () => {
    localStorage.setItem("confirm-expire", JSON.stringify(false));
    handleClose();
  };

  const handleExpireLane = () => {
    selectedLanes.forEach(lane => {
      const payload = {
        id: lane.id,
        userId: userIdMcld
      };

      if (capacityType == "posted-truck") {
        CarrierService.ExpirePostedTruck(instance, payload).then(() => {
          setRefreshPage(true);
          handleClose();
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      } else {
        CarrierService.ExpirePreferredLane(instance, payload).then(() => {
          setRefreshPage(true);
          handleClose();
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      }
    });
  };

  useEffect(() => {
    let askConfirmation = JSON.parse(localStorage.getItem("confirm-expire"));
    if (askConfirmation) {
      localStorage.setItem("confirm-expire", JSON.stringify(askConfirmation));
      handleExpireLane();
    } else {
      localStorage.setItem("confirm-expire", JSON.stringify(confirmExpire));
      handleOpen();
    }
  }, []);

  return (
    <StyledModal
      label={"Expire this Lane?"}
      titleObject={
        <span style={{ display: "flex", justifyContent: "start" }}>
          <HourglassBottomIcon sx={{ fontSize: "24px", color: "black_solid.80" }} />
          <Typography variant="h2" marginLeft="10px">Expire this Lane?</Typography>
        </span>
      }
      open={isOpen}
      handleClose={handleClose}
    >
      <Box>
        {selectedLanes.map(lane => (
          <Typography key={lane.id} variant="body1" color="black_solid.60">
            {lane.originCity}, {lane.originState} {lane.destinationCity && `to ${lane.destinationCity}, ${lane.destinationState}`}
          </Typography>
        ))}
        <Box sx={{ display: "flex", margin: "50px 20px 0 0" }}>
          <FormControlLabel sx={{ marginRight: "90px" }}
            control={
              <Box sx={{ margin: "0 6px 0 8px" }}>
                <PrimaryCheckbox
                  checked={confirmExpire}
                  handleChange={e => {
                    setConfirmExpire(e.target.checked);
                    localStorage.setItem("confirm-expire", JSON.stringify(e.target.checked));
                  }}
                  color="black_solid.60"
                />
              </Box>
            }
            label={
              <Typography variant="body1" color="black_solid.60">Don&apos;t ask me again</Typography>
            }
          />
          <Box sx={{ marginLeft: "auto", marginRight: "20px" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleCancel}
            />
          </Box>
          <Box>
            <PrimaryButton
              label="Expire"
              width="60px"
              onClick={handleExpireLane}
            />
          </Box>
        </Box>
      </Box>
    </StyledModal>
  );
}

CarrierProfileCapacityExpireModal.propTypes = {
  setOpen: PropTypes.func.isRequired,
  userIdMcld: PropTypes.string,
  capacityType: PropTypes.string,
  selectedLanes: PropTypes.array.isRequired,
  setRefreshPage: PropTypes.func
};